import "./context/firebaseinit";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./global.css";
import "./index.css";
import { AppProvider } from "./context/MainContext/AppContext";
import ErrorBoundary from "./context/MainContext/ErrorBoundary";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <AppProvider>
    <BrowserRouter>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </BrowserRouter>
  </AppProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
